import * as Sentry from "@sentry/react";

export const isFromAppBundle = (event: Sentry.Event) => {
  const frames = event.exception?.values?.flatMap((value) => value.stacktrace?.frames ?? []) ?? [];
  if (frames.length === 0) return true;

  return frames.some((frame) => frame.filename?.includes("/static/js/"));
};
